import { useUIStore } from '@/core/stores/ui.store';
import { formatInstant } from '@/shared/lib/datetime/instant';

/**
 * Reactive canonical formatter for UTC `Instant` values. Binds the user's
 * `dateFormat` / `timeFormat` / `timezone` from the store and returns a formatter.
 *
 * The Instant analogue of `useDateFormat` + `formatPlannedDate`. Prefer this for
 * displaying `date-time` fields outside tasks (audit §6.1).
 *
 * @example
 * const formatInstant = useInstantFormat();
 * formatInstant(member.createdAt);                 // date only
 * formatInstant(entry.startTime, { showTime: true }); // date + time
 */
export function useInstantFormat() {
  const dateFormat = useUIStore((s) => s.dateFormat);
  const timeFormat = useUIStore((s) => s.timeFormat);
  const timezone = useUIStore((s) => s.timezone);

  return (iso: string | null | undefined, opts?: { showTime?: boolean }) =>
    formatInstant(iso, { dateFormat, timeFormat, timezone, showTime: opts?.showTime });
}
